import { HardBreak } from 'tiptap-extensions';
import { chainCommands, exitCode } from 'tiptap-commands';

export default class EnterBreak extends HardBreak {
  keys({ type }) {
    const command = chainCommands(exitCode, (state, dispatch) => {
      dispatch(state.tr.replaceSelectionWith(type.create()));
      return true;
    });
    return {
      Enter: command,
    };
  }
}
